import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.reflect.construct";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _assertThisInitialized from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.array.is-array";
import "core-js/modules/es6.array.map";
import _toConsumableArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _get from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/get";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import "core-js/modules/es6.array.from";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.set";
import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { defineHidden, FluidType, is, each, isFluidValue, createInterpolator, toArray, isEqual, Globals, needsInterpolation, useForceUpdate, useIsomorphicLayoutEffect } from '@react-spring/shared';
import _extends from '@babel/runtime/helpers/esm/extends';
import { deprecateInterpolate } from '@react-spring/shared/deprecations';
import { to as _to2, createAnimatedTransform, createAnimatedStyle, frameLoop, applyAnimatedValues, getComponentProps } from '@react-spring/shared/globals';
import { createInterpolator as createInterpolator$1, is as is$1 } from '@react-spring/shared';
import React, { forwardRef, useRef } from 'react';
var AnimatedType = '__$AnimatedType';
/** Returns true for `Animated` nodes. Returns false for `SpringValue` objects. */

var isAnimated = function isAnimated(value) {
  return !!(value && value[AnimatedType]);
};

var Animated = /*#__PURE__*/function () {
  function Animated() {
    _classCallCheck(this, Animated);

    defineHidden(this, AnimatedType, 1);
  }
  /** Returns every animated number used by this node. */


  _createClass(Animated, [{
    key: "getPayload",
    value: function getPayload() {
      return this.payload || [];
    }
  }]);

  return Animated;
}();
/** The `AnimatedProps` class sets this before initializing */


Animated.context = null;

var isAnimationValue = function isAnimationValue(value) {
  return (value && value[FluidType]) == 2;
};

var nextId = 1;
/**
 * A kind of `FluidValue` that manages an `AnimatedValue` node.
 *
 * Its underlying value can be accessed and even observed.
 */

var AnimationValue = /*#__PURE__*/function () {
  function AnimationValue(key) {
    _classCallCheck(this, AnimationValue);

    this.key = key;
    this.id = nextId++;
    this._priority = 0;
    this._children = new Set();
    defineHidden(this, FluidType, 2);
  }
  /** @internal Controls the order in which animations are updated */


  _createClass(AnimationValue, [{
    key: "get",

    /** Get the current value */
    value: function get() {
      // The node doesn't exist until the first update, which normally isn't an
      // issue but it can be for tests.
      return this.node && this.node.getValue();
    }
    /** Create a spring that maps our value to another value */

  }, {
    key: "to",
    value: function to() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _to2(this, args);
    }
    /** @deprecated Use the `to` method instead. */

  }, {
    key: "interpolate",
    value: function interpolate() {
      deprecateInterpolate();

      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _to2(this, args);
    }
    /** @internal */

  }, {
    key: "addChild",
    value: function addChild(child) {
      if (!this._children.size) this._attach();

      this._children.add(child);
    }
    /** @internal */

  }, {
    key: "removeChild",
    value: function removeChild(child) {
      this._children["delete"](child);

      if (!this._children.size) this._detach();
    }
    /** @internal */

  }, {
    key: "onParentPriorityChange",
    value: function onParentPriorityChange(priority, _parent) {
      // Assume we only have one parent.
      this.priority = priority + 1;
    }
  }, {
    key: "_attach",
    value: function _attach() {}
  }, {
    key: "_detach",
    value: function _detach() {}
    /** Notify observers of a change to our value */

  }, {
    key: "_onChange",
    value: function _onChange(value, idle) {
      if (idle === void 0) {
        idle = false;
      } // Clone "_children" so it can be safely mutated by the loop.


      for (var _i = 0, _Array$from = Array.from(this._children); _i < _Array$from.length; _i++) {
        var observer = _Array$from[_i];

        if (is.fun(observer)) {
          observer(value, this);
        } else {
          observer.onParentChange(value, idle, this);
        }
      }
    }
    /** Notify observers of a change to our priority */

  }, {
    key: "_onPriorityChange",
    value: function _onPriorityChange(priority) {
      var _this = this;

      each(this._children, function (observer) {
        if (!is.fun(observer)) {
          observer.onParentPriorityChange(priority, _this);
        }
      });
    }
    /** Reset our node and the nodes of every descendant */

  }, {
    key: "_reset",
    value: function _reset(goal) {
      this.node.reset(!this.idle, goal);
      each(this._children, function (observer) {
        if (isAnimationValue(observer)) {
          observer._reset(goal);
        }
      });
    }
  }, {
    key: "priority",
    get: function get() {
      return this._priority;
    },
    set: function set(priority) {
      if (this._priority != priority) {
        this._priority = priority;

        this._onPriorityChange(priority);
      }
    }
  }]);

  return AnimationValue;
}();
/** An object containing `Animated` nodes */


var AnimatedObject = /*#__PURE__*/function (_Animated) {
  _inherits(AnimatedObject, _Animated);

  var _super = _createSuper(AnimatedObject);

  function AnimatedObject(source) {
    var _this2;

    _classCallCheck(this, AnimatedObject);

    if (source === void 0) {
      source = null;
    }

    _this2 = _super.call(this);

    _this2.setValue(source);

    return _this2;
  }

  _createClass(AnimatedObject, [{
    key: "getValue",
    value: function getValue(animated) {
      if (!this.source) return null;
      var values = {};
      each(this.source, function (source, key) {
        if (isAnimated(source)) {
          values[key] = source.getValue(animated);
        } else if (isFluidValue(source)) {
          values[key] = source.get();
        } else if (!animated) {
          values[key] = source;
        }
      });
      return values;
    }
    /** Replace the raw object data */

  }, {
    key: "setValue",
    value: function setValue(source) {
      this.source = source;
      this.payload = this._makePayload(source);
    }
  }, {
    key: "reset",
    value: function reset(isActive, _goal) {
      if (this.payload) {
        each(this.payload, function (node) {
          return node.reset(isActive);
        });
      }
    }
    /** Create a payload set. */

  }, {
    key: "_makePayload",
    value: function _makePayload(source) {
      if (source) {
        var payload = new Set();
        each(source, this._addToPayload, payload);
        return Array.from(payload);
      }
    }
    /** Add to a payload set. */

  }, {
    key: "_addToPayload",
    value: function _addToPayload(source) {
      var _this3 = this;

      if (isFluidValue(source)) {
        if (Animated.context) {
          Animated.context.dependencies.add(source);
        }

        if (isAnimationValue(source)) {
          source = source.node;
        }
      }

      if (isAnimated(source)) {
        each(source.getPayload(), function (node) {
          return _this3.add(node);
        });
      }
    }
  }]);

  return AnimatedObject;
}(Animated);

var AnimatedStyle = /*#__PURE__*/function (_AnimatedObject) {
  _inherits(AnimatedStyle, _AnimatedObject);

  var _super2 = _createSuper(AnimatedStyle);

  function AnimatedStyle(style) {
    _classCallCheck(this, AnimatedStyle);

    return _super2.call(this, style || null);
  }

  _createClass(AnimatedStyle, [{
    key: "setValue",
    value: function setValue(style) {
      _get(_getPrototypeOf(AnimatedStyle.prototype), "setValue", this).call(this, style && style.transform && createAnimatedTransform ? _extends({}, style, {
        transform: createAnimatedTransform(style.transform)
      }) : style);
    }
  }]);

  return AnimatedStyle;
}(AnimatedObject);
/** An animated number or a native attribute value */


var AnimatedValue = /*#__PURE__*/function (_Animated2) {
  _inherits(AnimatedValue, _Animated2);

  var _super3 = _createSuper(AnimatedValue);

  function AnimatedValue(_value) {
    var _this4;

    _classCallCheck(this, AnimatedValue);

    _this4 = _super3.call(this);
    _this4._value = _value;
    _this4.done = true;

    if (is.num(_this4._value)) {
      _this4.lastPosition = _this4._value;
    }

    return _this4;
  }

  _createClass(AnimatedValue, [{
    key: "getPayload",
    value: function getPayload() {
      return [this];
    }
  }, {
    key: "getValue",
    value: function getValue() {
      return this._value;
    }
    /**
     * Set the current value and optionally round it.
     *
     * The `step` argument does nothing whenever it equals `undefined` or `0`.
     * It works with fractions and whole numbers. The best use case is (probably)
     * rounding to the pixel grid with a step of:
     *
     *      1 / window.devicePixelRatio
     */

  }, {
    key: "setValue",
    value: function setValue(value, step) {
      if (is.num(value)) {
        this.lastPosition = value;

        if (step) {
          value = Math.round(value / step) * step;

          if (this.done) {
            this.lastPosition = value;
          }
        }
      }

      if (this._value === value) {
        return false;
      }

      this._value = value;
      return true;
    }
  }, {
    key: "reset",
    value: function reset(isActive, _goal) {
      this.done = false;

      if (is.num(this._value)) {
        this.elapsedTime = 0;
        this.lastPosition = this._value;
        if (!isActive) this.lastVelocity = null;
        this.v0 = null;
      }
    }
  }], [{
    key: "create",
    value: function create(from, _to) {
      return new AnimatedValue(from);
    }
  }]);

  return AnimatedValue;
}(Animated);
/**
 * `Into` springs are memoized interpolators that react to their dependencies.
 *  The memoized result is updated whenever a dependency changes.
 */


var Into = /*#__PURE__*/function (_AnimationValue) {
  _inherits(Into, _AnimationValue);

  var _super4 = _createSuper(Into);

  function Into(
  /** The source of input values */
  source, args) {
    var _this5;

    _classCallCheck(this, Into);

    _this5 = _super4.call(this);
    _this5.source = source;
    _this5.calc = createInterpolator.apply(void 0, _toConsumableArray(args));
    _this5.node = new AnimatedValue(_this5._compute());
    return _this5;
  }

  _createClass(Into, [{
    key: "_compute",
    value: function _compute() {
      var inputs = is.arr(this.source) ? this.source.map(function (node) {
        return node.get();
      }) : toArray(this.source.get());
      return this.calc.apply(this, _toConsumableArray(inputs));
    }
  }, {
    key: "_attach",
    value: function _attach() {
      var _this6 = this;

      // Start observing our "source" once we have an observer.
      var priority = 0;
      each(toArray(this.source), function (source) {
        priority = Math.max(priority, (source.priority || 0) + 1);
        source.addChild(_this6);
      });
      this.priority = priority;
    }
  }, {
    key: "_detach",
    value: function _detach() {
      var _this7 = this;

      // Stop observing our "source" once we have no observers.
      each(toArray(this.source), function (source) {
        source.removeChild(_this7);
      });
    }
    /** @internal */

  }, {
    key: "onParentChange",
    value: function onParentChange(_value, idle) {
      var node = this.node;

      if (idle && !node.done) {
        // We're not idle until every source is idle.
        node.done = toArray(this.source).every(function (source) {
          return !isAnimationValue(source) || source.idle;
        });
      } // TODO: only compute once per frame (note: we'll need to call "onParentChange")


      var value = this._compute();

      if (!isEqual(value, this.get())) {
        node.setValue(value);

        this._onChange(value, node.done);
      }
    }
    /** @internal */

  }, {
    key: "onParentPriorityChange",
    value: function onParentPriorityChange(_priority) {
      // Set our priority to 1 + the highest parent.
      this.priority = toArray(this.source).reduce(function (max, source) {
        return Math.max(max, (source.priority || 0) + 1);
      }, 0);
    }
  }, {
    key: "idle",
    get: function get() {
      return this.node.done;
    }
  }]);

  return Into;
}(AnimationValue);

Globals.assign({
  to: function to(source, args) {
    return new Into(source, args);
  },
  createAnimatedStyle: function createAnimatedStyle(style) {
    return new AnimatedStyle(style);
  }
});

var AnimatedString = /*#__PURE__*/function (_AnimatedValue) {
  _inherits(AnimatedString, _AnimatedValue);

  var _super5 = _createSuper(AnimatedString);

  function AnimatedString(from, to) {
    var _this8;

    _classCallCheck(this, AnimatedString);

    _this8 = _super5.call(this, 0);
    _this8._string = null;
    _this8._toString = createInterpolator$1({
      output: [from, to]
    });
    return _this8;
  }

  _createClass(AnimatedString, [{
    key: "getValue",
    value: function getValue() {
      var value = this._string;
      return value == null ? this._string = this._toString(this._value) : value;
    }
  }, {
    key: "setValue",
    value: function setValue(value) {
      if (!is$1.num(value)) {
        this._string = value;
        this._value = 1;
      } else if (_get(_getPrototypeOf(AnimatedString.prototype), "setValue", this).call(this, value)) {
        this._string = null;
      } else {
        return false;
      }

      return true;
    }
  }, {
    key: "reset",
    value: function reset(isActive, goal) {
      if (goal) {
        this._toString = createInterpolator$1({
          output: [this.getValue(), goal]
        });
      }

      this._value = 0;

      _get(_getPrototypeOf(AnimatedString.prototype), "reset", this).call(this, isActive);
    }
  }], [{
    key: "create",
    value: function create(from, to) {
      if (to === void 0) {
        to = from;
      }

      if (is$1.str(from) && is$1.str(to)) {
        return new AnimatedString(from, to);
      }

      throw TypeError('Expected "from" and "to" to be strings');
    }
  }]);

  return AnimatedString;
}(AnimatedValue);
/** An array of animated nodes */


var AnimatedArray = /*#__PURE__*/function (_AnimatedObject2) {
  _inherits(AnimatedArray, _AnimatedObject2);

  var _super6 = _createSuper(AnimatedArray);

  function AnimatedArray(from, to) {
    var _this9;

    _classCallCheck(this, AnimatedArray);

    _this9 = _super6.call(this, null);

    _get(_getPrototypeOf(AnimatedArray.prototype), "setValue", _assertThisInitialized(_this9)).call(_assertThisInitialized(_this9), _this9._makeAnimated(from, to));

    return _this9;
  }

  _createClass(AnimatedArray, [{
    key: "getValue",
    value: function getValue() {
      return this.source.map(function (node) {
        return node.getValue();
      });
    }
  }, {
    key: "setValue",
    value: function setValue(newValue) {
      var payload = this.getPayload(); // Reuse the payload when lengths are equal.

      if (newValue && newValue.length == payload.length) {
        each(payload, function (node, i) {
          return node.setValue(newValue[i]);
        });
      } else {
        // Remake the payload when length changes.
        this.source = this._makeAnimated(newValue);
        this.payload = this._makePayload(this.source);
      }
    }
    /** Convert the `from` and `to` values to an array of `Animated` nodes */

  }, {
    key: "_makeAnimated",
    value: function _makeAnimated(from, to) {
      if (to === void 0) {
        to = from;
      }

      return from ? from.map(function (from, i) {
        return (needsInterpolation(from) ? AnimatedString : AnimatedValue).create(from, to[i]);
      }) : [];
    }
  }], [{
    key: "create",
    value: function create(from, to) {
      return new AnimatedArray(from, to);
    }
  }]);

  return AnimatedArray;
}(AnimatedObject);

var AnimatedProps = /*#__PURE__*/function (_AnimatedObject3) {
  _inherits(AnimatedProps, _AnimatedObject3);

  var _super7 = _createSuper(AnimatedProps);

  function AnimatedProps(update) {
    var _this10;

    _classCallCheck(this, AnimatedProps);

    _this10 = _super7.call(this, null);
    _this10.update = update;
    /** Equals true when a re-render is scheduled for "end of frame" */

    _this10.dirty = false;
    return _this10;
  }

  _createClass(AnimatedProps, [{
    key: "setValue",
    value: function setValue(props, context) {
      if (!props) return; // The constructor passes null.

      if (context) {
        Animated.context = context;
      }

      _get(_getPrototypeOf(AnimatedProps.prototype), "setValue", this).call(this, props.style && createAnimatedStyle ? _extends({}, props, {
        style: createAnimatedStyle(props.style)
      }) : props);

      Animated.context = null;
    }
    /** @internal */

  }, {
    key: "onParentChange",
    value: function onParentChange() {
      var _this11 = this;

      if (!this.dirty) {
        this.dirty = true;
        frameLoop.onFrame(function () {
          _this11.dirty = false;

          _this11.update();
        });
      }
    }
    /** @internal */

  }, {
    key: "onParentPriorityChange",
    value: function onParentPriorityChange() {}
  }]);

  return AnimatedProps;
}(AnimatedObject);

var cacheKey = Symbol["for"]('AnimatedComponent');

var withAnimated = function withAnimated(Component) {
  return is.str(Component) ? createAnimatedComponent(Component) : Component[cacheKey] || (Component[cacheKey] = createAnimatedComponent(Component));
};

var createAnimatedComponent = function createAnimatedComponent(Component) {
  return forwardRef(function (rawProps, ref) {
    var instanceRef = useRef(null);
    var hasInstance = // Function components must use "forwardRef" to avoid being
    // re-rendered on every animation frame.
    !is.fun(Component) || Component.prototype.isReactComponent;
    var forceUpdate = useForceUpdate();
    var props = new AnimatedProps(function () {
      var instance = instanceRef.current;

      if (hasInstance && !instance) {
        return; // The wrapped component forgot to forward its ref.
      }

      var didUpdate = instance ? applyAnimatedValues(instance, props.getValue(true)) : false; // Re-render the component when native updates fail.

      if (didUpdate === false) {
        forceUpdate();
      }
    });
    var dependencies = new Set();
    props.setValue(rawProps, {
      dependencies: dependencies
    });
    useIsomorphicLayoutEffect(function () {
      each(dependencies, function (dep) {
        return dep.addChild(props);
      });
      return function () {
        return each(dependencies, function (dep) {
          return dep.removeChild(props);
        });
      };
    });
    return React.createElement(Component, Object.assign({}, getComponentProps(props.getValue()), {
      ref: hasInstance && function (value) {
        instanceRef.current = updateRef(ref, value);
      }
    }));
  });
};

function updateRef(ref, value) {
  if (ref) {
    if (is.fun(ref)) ref(value);else ref.current = value;
  }

  return value;
}
/**
 * Pass the given components to `withAnimated` and add the newly animated
 * components to `withAnimated` as properties.
 */


var extendAnimated = function extendAnimated(withAnimated, components, lowercase) {
  components.forEach(function (Component) {
    var key = getDisplayName(Component);

    if (lowercase) {
      key = key[0].toLowerCase() + key.slice(1);
    }

    withAnimated[key] = withAnimated(Component);
  });
  return withAnimated;
};

var getDisplayName = function getDisplayName(arg) {
  return is.str(arg) ? arg : arg && is.str(arg.displayName) ? arg.displayName : is.fun(arg) && arg.name || null;
};

export { Animated, AnimatedArray, AnimatedObject, AnimatedProps, AnimatedString, AnimatedStyle, AnimatedType, AnimatedValue, AnimationValue, Into, extendAnimated, isAnimated, isAnimationValue, withAnimated };